import { createServices } from '@vs/vsf-boot';
export default createServices({
  OrderMerchantVoucherController_createWorkConsume_c6f4df: {
    method: 'post',
    url: '/api/order-merchant/create-work-consume',
    parameterFomatter: (data?: {
      btoParam: CreateWorkConsumeBtoOrderMerchantServiceBto;
      extApiParam: any;
    }) => data,
    responseFormatter: (
      _,
      __,
      data?: ConsumeVoucherVoOrderMerchantEntranceWebVo,
    ) => data,
  },
});
